import React from 'react'
import PropTypes from 'prop-types'
import CustomIcon from 'shared/components/customIcon'
import { Text } from 'shared/components'
import styles from './styles'

const FormListItem = ({ title, css, icon, ...rest }) => (
  <div css={[styles.formListItem, css]} {...rest}>
    <Text size={11}>{title}</Text>
    {icon || <CustomIcon icon="angleRight" css={styles.carret} size={20} />}
  </div>
)

FormListItem.propTypes = {
  title: PropTypes.string,
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  icon: PropTypes.shape(),
}

export default FormListItem
